import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: SPACES.xl,
    flexWrap: 'wrap',
  },
  localWrapper: {
    [theme.breakpoints.down('tablet_s')]: {
      marginLeft: 'auto',
    },
  },
  headerTitle: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: FONTS.SIZES.xxxxl,
      lineHeight: 1.375,
    },
  },
  headerCode: {
    '&&': {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: FONTS.SIZES.xs,
      lineHeight: 1.4,
    },
  },
}))
